import { Dialog, DialogTitle, Typography, DialogContent, Grid, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { IBooking } from "../../../../../reducers/bookings/types";
import DepositPaymentView from "./DepositPaymentView";

interface IProps {
  booking: IBooking;
  handleClose: () => void;
}

const DepositPaymentDialog: React.FC<IProps> = (props) => {
  const [booking, setBooking] = useState<IBooking>();

  useEffect(() => {
    if (props.booking) {
      setBooking(props.booking)
    }
  }, [props.booking])

  if (!booking) {
    return <CircularProgress />
  }

  return (
    <Dialog
      fullWidth={true}
      open={true}
      onClose={props.handleClose}
      maxWidth="md"
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title" style={{ padding: "20px 24px 10px" }}>
        <Grid container item xs={12}>
          <Grid container item xs={6}><Typography variant="h2">{"Collect Security Deposit"}</Typography></Grid>
          <Grid container item xs={6} justifyContent="flex-end">
            <CloseIcon className="close-icon" onClick={props.handleClose} />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent style={{ paddingBottom: "20px" }}>
        <DepositPaymentView
          booking={props.booking}
          handleClose={props.handleClose}
        />
      </DialogContent>
    </Dialog>
  );
}

export default DepositPaymentDialog;